// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".expansion-view-msg-dialog.common-dialog[data-v-4799fc74] .el-dialog{width:var(--common-dialog-width)}.expansion-view-msg-dialog.common-dialog .msg-info[data-v-4799fc74]{padding:var(--base-size-16)}", ""]);
// Exports
module.exports = exports;
